import { Backdrop, CircularProgress } from '@/lib/mui';

interface Props {
  open: boolean;
}

export default function ScreenLoader({ open }: Props) {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
